import { format, parseISO } from 'date-fns';
import { resolveUserDisplayName } from '../components/operations/roll-off/details/order-details-constants';
export const PAYMENT_METHOD_STATUS_LABELS = {
    ACTIVE: 'Active',
    VERIFYING: 'Verifying',
    VERIFIED: 'Verified',
    UNVERIFIED: 'Unverified',
    EXPIRED: 'Expired',
    BLOCKED: 'Blocked',
    DELETED: 'Deleted',
};
export const PAYMENT_METHOD_STATUS_REASON_LABELS = {
    SUSPECTED_FRAUD: 'Suspected fraud',
    COMPROMISED_CARD: 'Compromised card',
    CUSTOMER_REQUEST: 'Customer request',
    CHARGEBACK_DISPUTE: 'Chargeback dispute',
    OTHER: 'Other',
};
/**
 * Statuses that mark a payment method as one an admin should be discouraged from charging.
 */
export const FLAGGED_PAYMENT_METHOD_STATUSES = ['BLOCKED', 'EXPIRED'];
export const isFlaggedPaymentMethodStatus = (status) => FLAGGED_PAYMENT_METHOD_STATUSES.includes(status);
/**
 * Builds a customerPaymentMethodID → status-details lookup covering only the flagged methods. Keyed on
 * the association rather than the processor's ID, since that is what the status belongs to and the
 * processor's ID is not guaranteed to be there. Methods still pending association have no status and
 * are skipped.
 */
export const buildFlaggedStatusDetailsMap = (paymentMethods, rosterMap) => {
    const map = new Map();
    for (const paymentMethod of paymentMethods) {
        if (!paymentMethod.status || !isFlaggedPaymentMethodStatus(paymentMethod.status))
            continue;
        const statusNote = paymentMethod.note;
        const changedByUserID = statusNote?.updatedByUserID ?? statusNote?.createdByUserID;
        const changedByProfile = changedByUserID ? rosterMap[changedByUserID] : undefined;
        map.set(paymentMethod.customerPaymentMethodID, {
            status: paymentMethod.status,
            statusLabel: PAYMENT_METHOD_STATUS_LABELS[paymentMethod.status],
            reasonLabel: statusNote?.reason ? PAYMENT_METHOD_STATUS_REASON_LABELS[statusNote.reason] : undefined,
            statusChangedAt: statusNote ? format(parseISO(statusNote.updatedAt), 'MMM d, yyyy h:mm a') : undefined,
            note: statusNote?.note,
            changedByUserName: changedByUserID
                ? (resolveUserDisplayName(changedByProfile, changedByProfile?.id, 'Unknown') ?? 'Unknown')
                : undefined,
        });
    }
    return map;
};
//# sourceMappingURL=rainforest-payment-method-status.js.map